import { render, staticRenderFns } from "./BnplPrescore.vue?vue&type=template&id=dc3c597e&scoped=true&"
import script from "./BnplPrescore.vue?vue&type=script&lang=js&"
export * from "./BnplPrescore.vue?vue&type=script&lang=js&"
import style0 from "./BnplPrescore.vue?vue&type=style&index=0&id=dc3c597e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc3c597e",
  null
  
)

export default component.exports